// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__n4WCD","item":"style_item__12a2S","number":"style_number__2ZBK5","label":"style_label__3L9Eg","img":"style_img__3P2WB","allbtn":"style_allbtn__3_us0"};